import {CATEGORY_GOOGLE_MAPS, CATEGORY_GOOGLE_RECAPTURE, CATEGORY_YOUTUBE, TagManager} from "./TagManager";

export class FormTagManager {
    constructor(el) {
        this.element = el;
        this.tagManagerEventDispatcher = new TagManager();

        this.tagManagerEventDispatcher.addEventListener(
            'changed-by-user',
            data => data.categoryId === CATEGORY_GOOGLE_RECAPTURE && location.reload()
        );

        this.tagManagerEventDispatcher.addEventListener('accepted', (acceptedCategory) => acceptedCategory === CATEGORY_GOOGLE_RECAPTURE && this.allow());
        this.tagManagerEventDispatcher.addEventListener('declined', (declinedCategory) => declinedCategory === CATEGORY_GOOGLE_RECAPTURE && this.disallow());
        this.showPreview();
    }

    static init() {
        const forms = [...document.querySelectorAll('.form')];
        forms.forEach(el => new FormTagManager(el));
    }

    showPreview() {
        const recaptureEl = this.element.querySelector('.g-recaptcha');
        if(recaptureEl) {
            const overlay = document.createElement('div');
            const errorText = document.createElement('div');
            const btn = document.createElement('a');
            const btnInner = document.createElement('span');
            btn.classList.add('btn','btn--prim');
            btnInner.classList.add('btn__inner');
            errorText.classList.add('form__overlay-error');
            overlay.classList.add('form__overlay');
            overlay.addEventListener('click', e => {
                e.preventDefault();
                this.tagManagerEventDispatcher.open();
            });
            this.element.appendChild(overlay);
            overlay.appendChild(errorText);

            errorText.innerText = recaptureEl.dataset.errorText;
            btnInner.innerText = recaptureEl.dataset.btnText;
            btn.appendChild(btnInner);
            overlay.appendChild(btn);
        }
    }


    allow() {
        const overlay = this.element.querySelector('.form__overlay');
        if(overlay){
            overlay.remove()
        }
    }

    disallow() {
        this.iframe = null;
        this.showPreview();
    }
}
